'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "constraint", "currencyCode", "bannerComponents", "baseFilterFamily", "style", "value", "valueBase", "isReadOnly", "isXoEnabled", "getFieldDefinitions", "getFilterFamilyObjectName", "getIsUngated", "getLabelString", "getOperatorLabel", "getOperators", "getReferencedObjectType", "getSpecialOptionsForReferenceType", "getValueResolver", "handleOpenEdit", "handleOperatorRemove", "showInvalidOptionErrors", "validateOperator"];
import * as MatchStatus from 'customer-data-filters/filterQueryFormat/MatchStatus';
import { List, Set as ImmutableSet, is, Map as ImmutableMap } from 'immutable';
import { addToKeyPath, getKeyPath } from 'customer-data-filters/filterQueryFormat/logic/LogicGroup';
import And from 'customer-data-filters/filterQueryFormat/logic/And';
import Constraint from '../filterQueryFormat/logic/Constraint';
import FilterEditorAndSeparator from './editor/FilterEditorAndSeparator';
import FilterEditorLogicGroupStatusTag from './editor/FilterEditorLogicGroupStatusTag';
import FilterEditorOperatorCreateButton from './editor/FilterEditorOperatorCreateButton';
import FilterEditorOperatorDisplay from './FilterEditorOperatorDisplay';
import FilterEditorOrGroupCondition from './editor/FilterEditorOrGroupCondition';
import FilterType from 'customer-data-filters/components/propTypes/FilterType';
import FormattedMessage from 'I18n/components/FormattedMessage';
import MatchStatusType from './propTypes/MatchStatusType';
import Or from 'customer-data-filters/filterQueryFormat/logic/Or';
import PropTypes from 'prop-types';
import { Component } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIList from 'UIComponents/list/UIList';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import getIn from 'transmute/getIn';
import identity from 'transmute/identity';
import isEmpty from 'transmute/isEmpty';
import memoize from 'transmute/memoize';
import partial from 'transmute/partial';
import FilterFamilyHeading from './FilterFamilyHeading';
import BannersContainer from './BannersContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const _isFieldNameDisplayBlocklisted = operator => {
  const fieldName = getIn(['field', 'name'], operator);
  const conditionsFieldNameDisplayBlocklist = ImmutableSet(['favoriteUserList']);
  return conditionsFieldNameDisplayBlocklist.contains(fieldName);
};
const _getDisplayConditions = ({
  conditions = List()
}) => conditions.filterNot(_isFieldNameDisplayBlocklisted);
const _pathToString = path => path.size > 0 ? path.join('-') : '0';
const tileStyleByStatus = {
  [MatchStatus.FAIL]: {
    backgroundColor: '#fdedee',
    borderColor: '#f2545b'
  },
  [MatchStatus.PASS]: {
    backgroundColor: '#e5f8f6',
    borderColor: '#00bda5'
  },
  [MatchStatus.PENDING]: {
    backgroundColor: ''
  }
};
export default class FilterEditorOperatorDisplayList extends Component {
  constructor(props) {
    super(props);
    // In new code, please use ES6 spread args rather than partials
    // for easier debugging and readability:
    // (...args) => myFunction('partiallyAppliedParam', ...args)
    this.handleCloneOrCondition = (index, ...args) => {
      const {
        handleOperatorClone,
        value
      } = this.props;
      const condition = _getDisplayConditions(value).get(index);
      const insertClone = this.partial(Or.insertAtPosition, index, condition);
      handleOperatorClone(insertClone, ...args);
    };
    this.handleShowAllConditions = () => {
      const {
        onShowAllConditionsClick
      } = this.props;
      this.setState({
        didClickShowAllConditions: true
      });
      setTimeout(() => this.setState({
        allConditionsLoaded: true
      }));
      onShowAllConditionsClick();
    };
    this.partial = memoize(partial);
    this.renderGroup = this.renderGroup.bind(this);
    this.renderOrGroupCondition = this.renderOrGroupCondition.bind(this);
    this.renderAndGroupConditions = this.renderAndGroupConditions.bind(this);
    this.state = {
      allConditionsLoaded: false,
      didClickShowAllConditions: false
    };
  }
  shouldComponentUpdate(prevProps, prevState) {
    const arePropsChanged = Object.keys(this.props).some(key => {
      if (key === 'value') {
        if (!is(this.props.value, prevProps.value)) {
          return true;
        }
        return false;
      } else {
        if (this.props[key] !== prevProps[key]) {
          return true;
        }
      }
      return false;
    });
    const isStateChanged = Object.keys(this.state).some(key => this.state[key] !== prevState[key]);
    return arePropsChanged || isStateChanged;
  }
  renderGroup(path, condition, key, itr) {
    const {
      baseFilterFamily,
      currencyCode,
      getFieldDefinitions,
      getIsUngated,
      getLabelString,
      getOperatorLabel,
      getOperators,
      getOperatorsForType,
      getReferencedObjectType,
      getSpecialOptionsForReferenceType,
      getValueResolver,
      handleOpenEdit,
      handleOperatorRemove,
      isReadOnly,
      isXoEnabled,
      showInvalidOptionErrors,
      validateOperator
    } = this.props;
    const {
      filterFamily
    } = condition;
    const conditionPath = path.push(key);
    const contents = And.isAnd(condition) && filterFamily ? this.renderFilterFamilyAndGroup(conditionPath, condition) : /*#__PURE__*/_jsx(FilterEditorOperatorDisplay, {
      currencyCode: currencyCode,
      filterFamily: filterFamily || baseFilterFamily,
      getFieldDefinitions: getFieldDefinitions,
      getIsUngated: getIsUngated,
      getLabelString: getLabelString,
      getOperatorLabel: getOperatorLabel,
      getOperators: getOperators,
      getOperatorsForType: getOperatorsForType,
      getReferencedObjectType: getReferencedObjectType,
      getSpecialOptionsForReferenceType: getSpecialOptionsForReferenceType,
      getValueResolver: getValueResolver,
      handleOpenEdit: handleOpenEdit,
      handleOperatorRemove: handleOperatorRemove,
      isReadOnly: isReadOnly,
      isXoEnabled: isXoEnabled,
      operator: condition,
      path: path.push(key),
      showInvalidOptionErrors: showInvalidOptionErrors,
      validateOperator: validateOperator
    }, `Operator-${key}`);
    if (!isXoEnabled) {
      return contents;
    }
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(UITile, {
        className: "p-x-0",
        closeable: false,
        compact: true,
        children: /*#__PURE__*/_jsx(UITileSection, {
          className: "p-all-0",
          children: contents
        })
      }), key !== itr.keySeq().last() && /*#__PURE__*/_jsx(FilterEditorAndSeparator, {})]
    }, `Group-${conditionPath}`);
  }
  renderFilterFamilyAndGroup(conditionPath, group) {
    const {
      addConditionDisabledTooltip,
      currencyCode,
      getFilterFamilyAndButtonTooltip,
      getFilterFamilyGroupHeading,
      getFilterFamilyObjectName,
      isReadOnly,
      isXoEnabled,
      handleOpenCreate,
      baseFilterFamily,
      getFieldDefinitions,
      getLabelString,
      getOperatorLabel,
      getOperators,
      getReferencedObjectType,
      getSpecialOptionsForReferenceType,
      getValueResolver,
      handleOpenEdit,
      handleOperatorRemove,
      isAddConditionDisabled,
      showInvalidOptionErrors,
      validateOperator,
      onBranchAssociationChange,
      getObjectAssociationOptions,
      value,
      getIsUngated,
      isAssociationSelectEnabled,
      onUserAction
    } = this.props;
    const {
      filterFamily,
      includeObjectsWithNoAssociatedObjects
    } = group;
    const filterFamilyAndButtonTooltip = getFilterFamilyAndButtonTooltip(filterFamily);
    return /*#__PURE__*/_jsxs(UIList, {
      className: "p-y-3",
      children: [/*#__PURE__*/_jsx(FilterFamilyHeading, {
        baseFilterFamily: baseFilterFamily,
        conditionPath: conditionPath,
        data: this.props.data,
        filterFamily: filterFamily,
        getFilterFamilyGroupHeading: getFilterFamilyGroupHeading,
        getFilterFamilyObjectName: getFilterFamilyObjectName,
        getObjectAssociationOptions: getObjectAssociationOptions,
        isAssociationSelectEnabled: isAssociationSelectEnabled,
        isReadOnly: isReadOnly,
        onBranchAssociationChange: onBranchAssociationChange,
        onUserAction: onUserAction,
        value: value
      }), _getDisplayConditions(group).map((innerCondition, key, itr) => /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(FilterEditorOperatorDisplay, {
          currencyCode: currencyCode,
          filterFamily: filterFamily || baseFilterFamily,
          getFieldDefinitions: getFieldDefinitions,
          getFilterFamilyObjectName: getFilterFamilyObjectName,
          getIsUngated: getIsUngated,
          getLabelString: getLabelString,
          getOperatorLabel: getOperatorLabel,
          getOperators: getOperators,
          getReferencedObjectType: getReferencedObjectType,
          getSpecialOptionsForReferenceType: getSpecialOptionsForReferenceType,
          getValueResolver: getValueResolver,
          handleOpenEdit: handleOpenEdit,
          handleOperatorRemove: handleOperatorRemove,
          includeObjectsWithNoAssociatedObjects: includeObjectsWithNoAssociatedObjects,
          isReadOnly: isReadOnly,
          isXoEnabled: isXoEnabled,
          operator: innerCondition,
          path: conditionPath.push(key),
          showInvalidOptionErrors: showInvalidOptionErrors,
          validateOperator: validateOperator
        }, `Operator-${key}`), key !== itr.keySeq().last() && /*#__PURE__*/_jsx(FilterEditorAndSeparator, {
          className: "p-left-4",
          isLineDisabled: true
        })]
      }, key)).valueSeq(), !isReadOnly && /*#__PURE__*/_jsx(FilterEditorOperatorCreateButton, {
        addConditionDisabledTooltip: addConditionDisabledTooltip,
        className: "m-left-4",
        "data-selenium-info": conditionPath.size > 0 ? `And-${_pathToString(conditionPath)}` : `And-${filterFamily}`,
        disabled: isAddConditionDisabled,
        filterFamilyAndButtonTooltip: filterFamilyAndButtonTooltip,
        isXoEnabled: isXoEnabled,
        onClick: this.partial(handleOpenCreate, this.partial(addToKeyPath, conditionPath), this.partial(getKeyPath, conditionPath), filterFamily),
        type: "and"
      })]
    }, `Group-And-${conditionPath}`);
  }
  renderOrGroupCondition(condition, index) {
    const {
      handleOperatorRemove,
      isReadOnly,
      matchStatus
    } = this.props;
    const path = List.of(index);
    const appendToSubGroup = this.partial(addToKeyPath, path);
    const conditionMatchStatus = matchStatus && matchStatus[index];
    const conditionStyle = conditionMatchStatus && tileStyleByStatus[conditionMatchStatus];
    const renderAndGroupConditions = this.partial(this.renderAndGroupConditions, condition, path, appendToSubGroup, conditionMatchStatus);
    return /*#__PURE__*/_jsx(FilterEditorOrGroupCondition, {
      conditionStyle: conditionStyle,
      data: this.props.data,
      handleClone: this.partial(this.handleCloneOrCondition, index),
      handleRemove: this.partial(handleOperatorRemove, path),
      isReadOnly: isReadOnly,
      isTitleVisible: index > 0,
      renderAndGroupConditions: renderAndGroupConditions
    }, path);
  }
  renderTopLevelAndGroup() {
    const {
      matchStatus,
      value
    } = this.props;
    const path = List.of();
    const appendToBaseGroup = this.partial(addToKeyPath, path);
    const conditionMatchStatus = matchStatus && matchStatus[0];
    if (conditionMatchStatus) {
      const conditionStyle = conditionMatchStatus && tileStyleByStatus[conditionMatchStatus];
      return /*#__PURE__*/_jsx(UITile, {
        className: "p-all-2",
        style: conditionStyle,
        children: this.renderAndGroupConditions(value, path, appendToBaseGroup, conditionMatchStatus)
      });
    }
    return this.renderAndGroupConditions(value, path, appendToBaseGroup, conditionMatchStatus);
  }
  renderTopLevelOrGroup() {
    const {
      addConditionDisabledTooltip,
      getInitialConditionCountCutoff,
      handleOpenCreate,
      isAddConditionDisabled,
      isReadOnly,
      isXoEnabled,
      style,
      value
    } = this.props;
    const {
      allConditionsLoaded,
      didClickShowAllConditions
    } = this.state;
    const conditions = _getDisplayConditions(value);
    const insertInOrGroup = this.partial(Or.insertAtPosition, conditions.size);
    const initialVisibleConditionCount = getInitialConditionCountCutoff(conditions.size);
    const areAllConditionsVisible = conditions.size <= initialVisibleConditionCount || allConditionsLoaded;
    const visibleConditions = !areAllConditionsVisible ? conditions.slice(0, initialVisibleConditionCount) : conditions;
    const showAllConditionsMessageProps = {
      message: didClickShowAllConditions ? 'customerDataFilters.FilterEditor.loadingConditions' : 'customerDataFilters.FilterEditor.loadMoreConditions',
      options: didClickShowAllConditions ? undefined : {
        count: conditions.size - visibleConditions.size
      }
    };
    return /*#__PURE__*/_jsxs(UIList, {
      style: Object.assign({}, style, {
        maxWidth: '100%'
      }),
      children: [visibleConditions.valueSeq().map(this.renderOrGroupCondition), !isReadOnly && /*#__PURE__*/_jsx(FilterEditorOperatorCreateButton, {
        addConditionDisabledTooltip: addConditionDisabledTooltip,
        className: "m-top-3",
        "data-selenium-info": "Or",
        disabled: isAddConditionDisabled,
        isXoEnabled: isXoEnabled,
        onClick: this.partial(handleOpenCreate, insertInOrGroup, identity, undefined),
        type: "or"
      }), !areAllConditionsVisible && /*#__PURE__*/_jsx(UIFlex, {
        justify: "center",
        children: /*#__PURE__*/_jsx(UIButton, {
          className: "justify-center m-top-3",
          disabled: didClickShowAllConditions,
          onClick: this.handleShowAllConditions,
          use: "link",
          children: /*#__PURE__*/_jsx(FormattedMessage, Object.assign({}, showAllConditionsMessageProps))
        })
      })]
    });
  }
  renderAndGroupConditions(logicGroup, path, fn, conditionMatchStatus) {
    const {
      addConditionDisabledTooltip,
      baseFilterFamily,
      getFilterFamilyObjectName,
      handleOpenCreate,
      isAddConditionDisabled,
      isReadOnly,
      isXoEnabled
    } = this.props;
    return /*#__PURE__*/_jsxs(UIList, {
      children: [_getDisplayConditions(logicGroup).map(this.partial(this.renderGroup, path)).valueSeq(), /*#__PURE__*/_jsxs("div", {
        className: "flex-row align-baseline justify-between",
        children: [!isReadOnly && /*#__PURE__*/_jsx(FilterEditorOperatorCreateButton, {
          addConditionDisabledTooltip: addConditionDisabledTooltip,
          className: 'm-top-3' + (isXoEnabled ? " flex-shrink-0" : ""),
          "data-selenium-info": `And-${_pathToString(path)}`,
          disabled: isAddConditionDisabled,
          isXoEnabled: isXoEnabled,
          onClick: this.partial(handleOpenCreate, fn, this.partial(getKeyPath, path), undefined),
          type: "and"
        }), conditionMatchStatus && /*#__PURE__*/_jsx(FilterEditorLogicGroupStatusTag, {
          filterFamily: baseFilterFamily,
          getFilterFamilyObjectName: getFilterFamilyObjectName,
          matchStatus: conditionMatchStatus
        })]
      }, "create-button")]
    });
  }
  render() {
    const _this$props = this.props,
      {
        className,
        constraint,
        currencyCode,
        bannerComponents,
        baseFilterFamily,
        style,
        value,
        valueBase,
        isReadOnly,
        isXoEnabled,
        getFieldDefinitions,
        getFilterFamilyObjectName,
        getIsUngated,
        getLabelString,
        getOperatorLabel,
        getOperators,
        getReferencedObjectType,
        getSpecialOptionsForReferenceType,
        getValueResolver,
        handleOpenEdit,
        handleOperatorRemove,
        showInvalidOptionErrors,
        validateOperator
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const dataAttributes = Object.keys(rest).filter(key => key.startsWith('data-')).reduce((acc, key) => {
      acc[key] = rest[key];
      return acc;
    }, {});

    /**
     * HubSpot/customer-data-filters/pull/460: this renders the constraint by
     * re-rendering this component with the constraint conditions passed in
     * as the `value` prop, the same way `valueBase` options are rendered.
     * @todo create a new component to encapsulate this once the API's finalized
     */
    const maybeConstraints = constraint && !isEmpty(constraint.conditions) ? /*#__PURE__*/_jsx(FilterEditorOperatorDisplayList, Object.assign({}, rest, {
      baseFilterFamily: baseFilterFamily,
      currencyCode: currencyCode,
      getFieldDefinitions: getFieldDefinitions,
      getFilterFamilyObjectName: getFilterFamilyObjectName,
      getIsUngated: getIsUngated,
      getLabelString: getLabelString,
      getOperatorLabel: getOperatorLabel,
      getOperators: getOperators,
      getReferencedObjectType: getReferencedObjectType,
      getSpecialOptionsForReferenceType: getSpecialOptionsForReferenceType,
      getValueResolver: getValueResolver,
      handleOpenEdit: handleOpenEdit,
      handleOperatorRemove: handleOperatorRemove,
      isReadOnly: true,
      isXoEnabled: isXoEnabled,
      showInvalidOptionErrors: showInvalidOptionErrors,
      validateOperator: validateOperator,
      value: constraint.conditions.first(),
      valueBase: null
    })) : undefined;
    return /*#__PURE__*/_jsxs("div", Object.assign({}, dataAttributes, {
      className: className,
      "data-selenium-test": "XOFilterEditor-operator-displaylist",
      style: style,
      children: [/*#__PURE__*/_jsx(BannersContainer, {
        children: bannerComponents
      }), valueBase && (!And.isAnd(valueBase) && !Or.isOr(valueBase) || !valueBase.conditions.isEmpty()) && /*#__PURE__*/_jsx(FilterEditorOperatorDisplayList, Object.assign({}, rest, {
        baseFilterFamily: baseFilterFamily,
        currencyCode: currencyCode,
        getFieldDefinitions: getFieldDefinitions,
        getIsUngated: getIsUngated,
        getLabelString: getLabelString,
        getOperatorLabel: getOperatorLabel,
        getOperators: getOperators,
        getReferencedObjectType: getReferencedObjectType,
        getSpecialOptionsForReferenceType: getSpecialOptionsForReferenceType,
        getValueResolver: getValueResolver,
        handleOpenEdit: handleOpenEdit,
        handleOperatorRemove: handleOperatorRemove,
        isReadOnly: true,
        isXoEnabled: isXoEnabled,
        showInvalidOptionErrors: showInvalidOptionErrors,
        validateOperator: validateOperator,
        value: valueBase,
        valueBase: null
      })), maybeConstraints, !And.isAnd(value) && !Or.isOr(value) && !_isFieldNameDisplayBlocklisted(value) && /*#__PURE__*/_jsx(FilterEditorOperatorDisplay, {
        currencyCode: currencyCode,
        filterFamily: baseFilterFamily,
        getFieldDefinitions: getFieldDefinitions,
        getIsUngated: getIsUngated,
        getLabelString: getLabelString,
        getOperatorLabel: getOperatorLabel,
        getOperators: getOperators,
        getReferencedObjectType: getReferencedObjectType,
        getSpecialOptionsForReferenceType: getSpecialOptionsForReferenceType,
        getValueResolver: getValueResolver,
        handleOpenEdit: handleOpenEdit,
        handleOperatorRemove: handleOperatorRemove,
        isReadOnly: isReadOnly,
        isXoEnabled: isXoEnabled,
        isZeroLevel: true,
        operator: value,
        path: List.of(),
        showInvalidOptionErrors: showInvalidOptionErrors,
        validateOperator: validateOperator
      }), And.isAnd(value) ? this.renderTopLevelAndGroup() : this.renderTopLevelOrGroup()]
    }));
  }
}
FilterEditorOperatorDisplayList.defaultProps = {
  isXoEnabled: false,
  value: And.of()
};
FilterEditorOperatorDisplayList.propTypes = {
  addConditionDisabledTooltip: PropTypes.node,
  bannerComponents: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  baseFilterFamily: PropTypes.string.isRequired,
  className: PropTypes.string,
  constraint: PropTypes.instanceOf(Constraint),
  currencyCode: PropTypes.string.isRequired,
  data: PropTypes.instanceOf(ImmutableMap),
  getFieldDefinitions: PropTypes.func.isRequired,
  getFilterFamilyAndButtonTooltip: PropTypes.func.isRequired,
  getFilterFamilyGroupHeading: PropTypes.func.isRequired,
  getFilterFamilyObjectName: PropTypes.func,
  getGroupTileStyle: PropTypes.func,
  getInitialConditionCountCutoff: PropTypes.func.isRequired,
  getIsUngated: PropTypes.func.isRequired,
  getLabelString: PropTypes.func.isRequired,
  getObjectAssociationOptions: PropTypes.func,
  getOperatorLabel: PropTypes.func.isRequired,
  getOperators: PropTypes.func.isRequired,
  getOperatorsForType: PropTypes.func,
  getReferencedObjectType: PropTypes.func.isRequired,
  getSpecialOptionsForReferenceType: PropTypes.func.isRequired,
  getValueResolver: PropTypes.func.isRequired,
  handleOpenCreate: PropTypes.func.isRequired,
  handleOpenEdit: PropTypes.func.isRequired,
  handleOperatorClone: PropTypes.func.isRequired,
  handleOperatorRemove: PropTypes.func.isRequired,
  isAddConditionDisabled: PropTypes.bool,
  isAssociationSelectEnabled: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  isXoEnabled: PropTypes.bool.isRequired,
  matchStatus: PropTypes.arrayOf(MatchStatusType),
  onBranchAssociationChange: PropTypes.func,
  onShowAllConditionsClick: PropTypes.func.isRequired,
  onUserAction: PropTypes.func,
  showInvalidOptionErrors: PropTypes.bool.isRequired,
  style: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  validateOperator: PropTypes.func.isRequired,
  value: FilterType.isRequired,
  /**
   * Allows creating "read only" portions of a filter.
   * Operators contained in `valueBase` cannot be removed or edited.
   * TODO: deprecate `valueBase`
   */
  valueBase: FilterType
};